import type { ComponentProps, JSX } from "solid-js";
import { splitProps } from "solid-js";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { cn } from "@/libs/cn";

export function JobCard(props: ComponentProps<typeof Card>) {
  const [local, rest] = splitProps(props, ["class"]);

  return <Card class={cn(local.class)} {...rest} />;
}

export function JobCardHeader(
  props: ComponentProps<typeof CardHeader> & { action?: JSX.Element },
) {
  const [local, rest] = splitProps(props, ["class", "action", "children"]);

  return (
    <CardHeader class={cn(local.class)} {...rest}>
      <div class="flex items-start justify-between gap-4">
        <div class="flex-1 min-w-0">{local.children}</div>
        {local.action && <div class="shrink-0">{local.action}</div>}
      </div>
    </CardHeader>
  );
}

export function JobCardContent(props: ComponentProps<typeof CardContent>) {
  const [local, rest] = splitProps(props, ["class"]);

  return <CardContent class={cn("pt-0 space-y-3", local.class)} {...rest} />;
}

export function JobCardFooter(props: ComponentProps<typeof CardFooter>) {
  const [local, rest] = splitProps(props, ["class"]);

  return <CardFooter class={cn(local.class)} {...rest} />;
}
